import BetaFeaturesSummaryPage from '@/sections/beta-features/summary/features-summary-page';
import BetaFeaturesSettingsPage from '@/sections/beta-features/settings/features-settings-page.vue';
import BetaFeaturesLogs from '@/sections/beta-features/history/features-history-page';

export default [
	{
		name: 'features-betafeatures',
		path: '/features',
		component: BetaFeaturesSummaryPage,
		props: route => ({
			search: route.query.search,
			sortBy: route.query.sortBy || 'date',
			sortDirection: route.query.sortDirection || 'desc'
		}),
		meta: {
			permissions: ['features.read']
		}
	},
	{
		name: 'features-edit',
		path: '/features/:id/edit',
		component: BetaFeaturesSettingsPage,
		props: route => ({
			id: parseInt(route.params.id)
		}),
		meta: {
			permissions: ['features.create', 'features.update']
		}
	},
	{
		name: 'features-history',
		path: '/features/:changedEntityId?/history',
		component: BetaFeaturesLogs,
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search,
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			SourceApplication: route.query.SourceApplication || 'VueSupport',
			changedEntityId: route.params.changedEntityId,
			recordStart: parseInt(route.query.recordStart) || 1,
			maxCount: parseInt(route.query.maxCount) || 10
		}),
		meta: {
			permissions: ['features.read']
		}
	}
];
